import React from 'react'
import Logo from '../Images/hqlogo2.png'
import { Link } from 'react-router-dom'

//changed hrefs to github stuff

function Header() {
  return (
    <div className="bg-gray-100">
    <header className="bg-gradient-to-r from-[#FF815D] via-[#ffc14d] to-[#F9F871]">
      <div className="container mx-auto px-4 py-6 flex items-center justify-between">
      <h1 className="text-3xl font-semibold text-indigo-600 animate-fade-in-up">
      <Link to="/" style={{ fontWeight: 'bold', textDecoration: 'none' }}>
              <img src={Logo} alt="Logo" className="w-14 h-14 mr-4 inline-block" />
              <span className='italic'>Abinand Nanthananthan</span>
            </Link>
      </h1>
        <nav>
          <ul className="flex space-x-4">
            <li>
              <a href="/Projects" className="text-2xl inline-block text-indigo-600 hover:text-customOrange text-gray-800 font-medium py-2 px-4 rounded-lg transition duration-300 ease-in-out animate-fade-in-up">
              <b>Projects</b>
              </a>
            </li>
            {/* <li>
              <a href="/Skills" className="text-2xl inline-block text-indigo-600 hover:text-customOrange text-gray-800 font-medium py-2 px-4 rounded-lg transition duration-300 ease-in-out animate-fade-in-up">
                <b>Skills</b>
              </a>
            </li> */}
            <li>
              <a href="/Contact" className="text-2xl inline-block text-indigo-600 hover:text-customOrange text-gray-800 font-medium py-2 px-4 rounded-lg transition duration-300 ease-in-out animate-fade-in-up">
                <b>Contact</b>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    </div>
  )
}

export default Header